<template lang="pug">
	.loader.section-transition-item 
		.loader-wrapper
			span
</template>

<script>
export default {
	name: 'Loader'
}
</script>

<style scoped lang="scss">
	.loader {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 800px;
		width: 100%;
    padding: 0 2rem;
    max-width: 1400px;
		margin: 0 auto;
		&-wrapper {
			position: relative;
			span {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 80px;
				height: 80px;
				background-color: rgba(50,50,50, 1);
				border-radius: 50%;
				&:before {
					content: 'Loading';
					font-size: 12px;
					color: #fff;
				}
				&:after {
					position: absolute;
					top: 0;
					left: 0;
					content: '';
					width: 80px;
					height: 80px;
					background-color: rgba(50,50,50, .6);
					border-radius: 50%;
					transform: scale(0.75);
					animation: pulse 1s infinite;
				}
				@keyframes pulse {
					0% { transform: scale(0.75); }
					100% { transform: scale(1.5); opacity: 0; }
				}
			}
		}
	}
	
</style>